// Application configuration constants

// Application Version
export const APP_VERSION = '0.0.2bt1';

// Timer Configuration
export const TIMER_CONFIG = {
  // Chat session timer in seconds
  CHAT_DURATION_SECONDS: 600, // 1 minute
  
  // Timer warning threshold in seconds (when to show red pulsing)
  WARNING_THRESHOLD_SECONDS: 30,
  
  // Timer update interval in milliseconds
  UPDATE_INTERVAL_MS: 1000,

  MATCHMAKING_DURATION_SECONDS: 30,
};

// Chat Configuration
export const CHAT_CONFIG = {
  // Maximum message length
  MAX_MESSAGE_LENGTH: 500,
  
  // Typing indicator timeout in milliseconds
  TYPING_TIMEOUT_MS: 3000,
  
  // Chat UI settings
  AUTO_OPEN_DURATION_MS: 5000, // Auto-close after 5 seconds of inactivity
  MAX_VISIBLE_MESSAGES: 50,
  MESSAGE_FADE_DURATION_MS: 300,
  
  // PubSub channel names
  PUBSUB_CHANNELS: {
    AVATAR_SELECTION: 'avatar-selection',
    BACKGROUND_CHANGE: 'background-change',
    SKIP_ROOM: 'skip-room',
    TIMER_COMPLETE: 'timer-complete',
    AVATAR_ID: 'avatar-id',
    CHAT_MESSAGES: 'chat-messages',
    TYPING_INDICATOR: 'typing-indicator',
  },
};

// UI Configuration
export const UI_CONFIG = {
  // Animation durations in milliseconds
  FADE_DURATION_MS: 300,
  PULSE_DURATION_MS: 2000,
  
  // Delays for various actions
  MEETING_LEAVE_DELAY_MS: 1000,
  BACKGROUND_PUBLISH_THROTTLE_MS: 100,
  
  // Z-index values
  Z_INDEX: {
    TIMER: 1000,
    CHAT_OVERLAY: 999,
    OVERLAY: 998,
    POPUP: 997,
  },
  
  // Mobile warning popup control
  SHOW_MOBILE_WARNING: false,
};

// Meeting Configuration
export const MEETING_CONFIG = {
  // Audio settings
  AUDIO_CONFIG: {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
    sampleRate: 48000,
    channelCount: 1,
  },
  
  // Preferred codec
  PREFERRED_CODEC: 'opus',
  
  // Multi-stream enabled
  MULTI_STREAM: true,
};

// Export all configurations
const config = {
  TIMER: TIMER_CONFIG,
  CHAT: CHAT_CONFIG,
  UI: UI_CONFIG,
  MEETING: MEETING_CONFIG,
};

export default config;
